import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';

const TemplateDisplayWithClipboard = ({ templateText }) => {
    return (
        <span>
            {`{{${templateText}}} `}
            <OverlayTrigger
                overlay={
                    <Popover id={`template-popover-${templateText}`}>
                        <Popover.Content>Copy label to clipboard</Popover.Content>
                    </Popover>
                }
            >
                <FaRegCopy
                    style={{ cursor: 'pointer' }}
                    onClick={async () => {
                        await navigator.clipboard.writeText(`{{${templateText}}}`);
                    }}
                />
            </OverlayTrigger>
        </span>
    );
};

TemplateDisplayWithClipboard.propTypes = {
    templateText: PropTypes.string.isRequired,
};

export default TemplateDisplayWithClipboard;
